import * as R from 'ramda';

interface DistributionValue {
  value: number;
  range: number;
}

export default R.compose(
  (values: DistributionValue[]) => {
    if (values.length < 2) {
      return values;
    }

    const edge = values.pop() as DistributionValue;
    const last = values.pop() as DistributionValue;

    return [...values, { ...last, value: last.value + edge.value }];
  },
  R.sortBy(R.prop('range')),
  R.values,
  R.mapObjIndexed((value, range) => ({ range: parseInt(range, 10), value })),
);
